import React, { useState } from "react";

const Faq = ({ landingPageData }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleAccordionClick = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  return (
    <div
      className="p-8  lg:px-[9%] xl:px-[10%] 2xl:px-[11%] 3xl:px-[14%] 4xl:px-[16%] 5xl:px-[17%] 6xl:px-[21%] 7xl:px-[21%] lg:mt-16"
      id="faq"
    >
      <div className="lg:hidden block">
        {/* heading */}
        <div className=" w-full">
          <h2 className=" text-30 lg:text-34 font-bold text-start">
            {landingPageData.faqSection.title1}
          </h2>
        </div>
        <div className="w-full justify-start">
          <div className="text-12 lg:text-14 font-[400] bg-faqChip rounded-full max-w-180 w-full flex justify-center px-2 py-2 mt-4">
            <h1 className="text-blue">{landingPageData.faqSection.title2}</h1>
          </div>
        </div>
      </div>
      <div className="flex flex-col justify-center items-center">
        <div className="grid grid-cols-1 lg:grid-cols-5 lg:gap-10 ">
          <div className="mt-8 col-span-3">
            <div className="lg:block hidden">
              {/* heading */}
              <div className=" w-full">
                <h2 className="text-30 lg:text-34 ml-6 font-bold text-start">
                  {landingPageData.faqSection.title1}
                </h2>
              </div>
              <div className="w-full justify-start">
                <div className="text-12 lg:text-14 font-[400] bg-faqChip rounded-full max-w-[200px] w-full flex justify-center px-2 py-2 mt-4">
                  <h1 className="text-blue">
                    {landingPageData.faqSection.title2}
                  </h1>
                </div>
              </div>
            </div>

            {/* Questions Section */}
            <div className="grid grid-cols-1 mt-3">
              {landingPageData.faqSection.questions.map((question, index) => (
                <div
                  key={index}
                  className="bg-white text-blue-500  shadow-faq rounded-2xl mt-5 cursor-pointer"
                  onClick={() => handleAccordionClick(index)}
                >
                  <div className="p-4">
                    <h3 className="text-16 lg:text-18 font-[700] flex justify-between items-center">
                      {question.question}
                      <span
                        className={`transition-transform duration-300 ${
                          index === activeIndex ? "rotate-0" : "rotate-180"
                        }`}
                      >
                        <svg
                          width="16"
                          height="16"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="text-blue-500"
                          title1
                        >
                          <path
                            d="M8 15l4-4 4 4"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </span>
                    </h3>
                    {index === activeIndex && (
                      <div className="mt-2 text-blue-500">
                        <p className="text-14 lg:text-16 text-textBlack">
                          {question.answer}
                        </p>
                      </div>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right Side Image (Moved on Top for Mobile) */}
          <div className="order-first lg:order-last col-span-2 flex justify-center items-center ">
            <img
              src="/images/Faq/Frame.webp"
              alt="faq"
              className=" md:w-[60%] lg:w-[100%] "
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Faq;
